/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const undo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.068 7.966a5.966 5.966 0 1 1 5.966 5.966m-3.898-7L3.068 9 1 6.932"
    />
  </svg>
)
export default undo
